<template>
  <header>
    <div class="utility desktop-only">
      <ResponsiveContainer
        ><div class="utility-row">
          <div class="preference-row">
            <PreferenceDropdown v-model="lang" aria-label="Language" :options="languageOptions" />
            <PreferenceDropdown v-model="currency" aria-label="Currency" :options="currencyOptions" />
          </div>
          <div class="account">
            <template v-if="logged"
              ><router-link to="/account">{{ userLabel }}</router-link
              ><button @click="signOut">Logout</button></template
            ><template v-else
              ><router-link to="/login">Login</router-link
              ><router-link to="/register">Register</router-link></template
            >
          </div>
        </div></ResponsiveContainer
      >
    </div>
    <ResponsiveContainer
      ><div class="head">
        <button
          class="menu mobile-only"
          aria-label="Open menu"
          @click="drawer = true"
        >
          <font-awesome-icon :icon="icons.menu" /></button
        ><router-link class="logo" to="/" aria-label="WishShop home"><img src="/brand/wish-header-black.png" alt="WishShop"></router-link
        ><SearchBar />
        <div class="actions desktop-only">
          <router-link to="/compare" class="header-tool"
            ><span class="tool-icon-wrap"><font-awesome-icon :icon="icons.compare" /><strong>{{ compareCount }}</strong></span
            ><small>Compare</small></router-link
          ><router-link to="/wishlist"
            class="header-tool"><span class="tool-icon-wrap"><font-awesome-icon :icon="icons.wishlist" /><strong>{{ wishlistCount }}</strong></span
            ><small>Wishlist</small></router-link
          ><button class="header-tool" @click="cartOpen = true">
            <span class="tool-icon-wrap"><font-awesome-icon :icon="icons.cart" /><strong>{{ cartCount }}</strong></span><small>Cart</small>
          </button>
        </div>
        <button class="mobile-only mobile-cart" @click="cartOpen = true">
          <font-awesome-icon :icon="icons.cart" /><b>{{ cartCount }}</b>
        </button>
      </div></ResponsiveContainer
    >
    <nav class="desktop-only">
      <template v-for="item in nav"><a v-if="item.href" :key="item.label" :href="item.href">{{ item.label }}</a><router-link v-else :key="item.label" :to="item.to">{{ item.label }}</router-link></template>
    </nav>
    <MobileDrawer
      :open="drawer"
      :items="mobileNav"
      @close="drawer = false"
    /><CartDrawer :open="cartOpen" @close="cartOpen = false" />
    <nav class="mobile-bottom mobile-only">
      <router-link to="/"><font-awesome-icon :icon="icons.home" /><span>Home</span></router-link
      ><router-link to="/products"><font-awesome-icon :icon="icons.categories" /><span>Categories</span></router-link
      ><router-link class="cart-link" to="/cart"
        ><span class="bottom-icon"><font-awesome-icon :icon="icons.cart" /><b>{{ cartCount }}</b></span><span>Cart</span></router-link
      ><button type="button" @click="openChat"><font-awesome-icon :icon="icons.chat" /><span>Chat</span></button
      ><router-link :to="logged ? '/account' : '/login'"><font-awesome-icon :icon="icons.account" /><span>Account</span></router-link>
    </nav>
  </header>
</template>
<script>
import ResponsiveContainer from "./ResponsiveContainer.vue";
import SearchBar from "./SearchBar.vue";
import MobileDrawer from "./MobileDrawer.vue";
import CartDrawer from "./CartDrawer.vue";
import PreferenceDropdown from "./PreferenceDropdown.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faArrowRightArrowLeft } from "@fortawesome/free-solid-svg-icons/faArrowRightArrowLeft";
import { faBagShopping } from "@fortawesome/free-solid-svg-icons/faBagShopping";
import { faBars } from "@fortawesome/free-solid-svg-icons/faBars";
import { faHouse } from "@fortawesome/free-solid-svg-icons/faHouse";
import { faLayerGroup } from "@fortawesome/free-solid-svg-icons/faLayerGroup";
import { faComments } from "@fortawesome/free-solid-svg-icons/faComments";
import { faUser } from "@fortawesome/free-solid-svg-icons/faUser";
import { faHeart } from "@fortawesome/free-regular-svg-icons/faHeart";
import { toast } from "../utils/toast";
export default {
  components: { ResponsiveContainer, SearchBar, MobileDrawer, CartDrawer, PreferenceDropdown, FontAwesomeIcon },
  data: () => ({
    drawer: false,
    cartOpen: false,
    icons: { compare: faArrowRightArrowLeft, wishlist: faHeart, cart: faBagShopping, menu: faBars, home: faHouse, categories: faLayerGroup, chat: faComments, account: faUser },
  }),
  computed: {
    nav() {
      return [
        { label: this.$t("home"), to: "/" },
        { label: this.$t("products"), to: "/products" },
        { label: this.$t("registerStore"), href: "/promote/#/merchantSettled" },
        { label: this.lang === 'zh-CN' ? '查看精选卖家' : this.$t("sellers"), to: "/sellers" },
      ];
    },
    cartCount() {
      return this.$store.getters["cart/count"];
    },
    wishlistCount() {
      return this.$store.getters["wishlist/count"];
    },
    compareCount() {
      return this.$store.getters["compare/count"];
    },
    currencies() { return this.$store.state.preferences.currencies; },
    languageOptions() {
      return [
        { value: "zh-CN", label: "简体中文", displayLabel: "中文", flagSrc: "/brand/flags/cn.svg" }, { value: "en", label: "English", flagSrc: "/brand/flags/us.svg" },
        { value: "zh-TW", label: "繁體中文", flagSrc: "/brand/flags/tw.svg" }, { value: "ja", label: "日本語", flagSrc: "/brand/flags/jp.svg" },
        { value: "id", label: "Bahasa Indonesia", flagSrc: "/brand/flags/id.svg" }, { value: "vi", label: "Tiếng Việt", flagSrc: "/brand/flags/vn.svg" },
        { value: "th", label: "ไทย", flagSrc: "/brand/flags/th.svg" },
      ];
    },
    currencyOptions() {
      const symbols = { USD: "$", EUR: String.fromCharCode(8364), GBP: String.fromCharCode(163), JPY: String.fromCharCode(165), AUD: "A$", CAD: "C$", SGD: "S$" };
      const names = new Intl.DisplayNames(['en'], { type: 'currency' });
      return this.currencies.map((item) => ({ value: item.code, label: `${item.code === 'USD' ? 'U.S. Dollar' : (item.name || names.of(item.code))} ${symbols[item.code] || item.symbol || item.sign || item.code}` }));
    },
    logged() {
      return this.$store.getters["auth/isLoggedIn"];
    },
    user() {
      return this.$store.getters["auth/user"] || {};
    },
    userLabel() {
      return (
        this.user.username ||
        this.user.email ||
        this.user.usercode ||
        "My account"
      );
    },
    mobileNav() {
      const items = [
        ...this.nav,
        { label: `Wishlist (${this.wishlistCount})`, to: "/wishlist" },
        { label: `Compare (${this.compareCount})`, to: "/compare" },
        { label: `Cart (${this.cartCount})`, to: "/cart" },
      ];
      if (!this.logged)
        items.push(
          { label: "Login", to: "/login" },
          { label: "Register", to: "/register" }
        );
      return items;
    },
    lang: {
      get() {
        return this.$store.state.preferences.language;
      },
      set(value) {
        this.$store.commit("preferences/SET_LANG", value);
      },
    },
    currency: {
      get() {
        return this.$store.state.preferences.currency;
      },
      set(value) {
        this.$store.commit("preferences/SET_CURRENCY", value);
      },
    },
  },
  async created() {
    await this.$store.dispatch("preferences/loadCurrencies");
    await this.$store.dispatch("auth/restore");
    if (this.logged) this.$store.dispatch("wishlist/load");
  },
  methods: {
    openChat() { window.dispatchEvent(new CustomEvent('wishshop:open-chat')); },
    async signOut() {
      await this.$store.dispatch("auth/logout");
      this.$store.commit("wishlist/SET", { key: "items", value: [] });
      toast("Signed out.");
      if (this.$route.meta.requiresAuth) this.$router.push("/");
    },
  },
};
</script>
<style scoped>
header {
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 30;
  border-bottom: 1px solid var(--line);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
.utility {
  border-bottom: 1px solid var(--line);
  font-size: 12px;
  color: var(--muted);
}
.utility-row {
  height: 31px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.preference-row { display:flex; align-items:center; gap:12px; }
.account {
  display: flex;
  gap: 16px;
  align-items: center;
}
.account button,
.actions button {
  border: 0;
  background: transparent;
  padding: 0;
  color: inherit;
}
.head {
  height: 64px;
  display: flex;
  align-items: center;
  gap: 30px;
}
.logo {
  width: 210px;
  display:flex;
  align-items:center;
}
.logo img{display:block;width:174px;height:auto;max-height:48px}
.actions {
  display: flex;
  gap: 18px;
  white-space: nowrap;
}
.actions a,
.actions button {
  display: flex;
  align-items: center;
  gap: 7px;
}
.header-tool { flex-direction:column; justify-content:center; min-width:52px; }
.header-tool{border-radius:var(--radius-sm);padding:7px 8px!important;cursor:pointer;transition:background .18s var(--ease),color .18s var(--ease),transform .18s var(--ease)}
.header-tool:hover{background:#f7f8fa;color:var(--brand);transform:translateY(-1px)}
.tool-icon-wrap { position:relative; display:inline-flex; color:#333; font-size:21px; }
.tool-icon-wrap strong { position:absolute; top:-9px; right:-13px; }
.actions small {
  font-size: 13px;
}
.actions strong,
.mobile-cart b,
.mobile-bottom b {
  min-width: 20px;
  height: 20px;
  border-radius: 50%;
  display: inline-grid;
  place-items: center;
  background: var(--brand);
  color: #fff;
  font-size: 11px;
}
.menu,
.mobile-cart {
  border: 0;
  background: transparent;
  padding: 8px 0;
}
.mobile-cart {
  margin-left: auto;
  white-space: nowrap;
  align-items: center;
  gap: 6px;
}
header > nav.desktop-only {
  height: 40px;
  border-top: 1px solid var(--line);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 42px;
  font-weight: 600;
  font-size: 13px;
}
header > nav.desktop-only a.router-link-exact-active {
  color: var(--brand);
}
header > nav.desktop-only a{position:relative;padding:11px 2px;transition:color .18s var(--ease)}
header > nav.desktop-only a:after{content:'';position:absolute;left:50%;right:50%;bottom:0;height:2px;background:var(--brand);transition:left .2s var(--ease),right .2s var(--ease)}
header > nav.desktop-only a:hover:after,header > nav.desktop-only a.router-link-exact-active:after{left:0;right:0}
.mobile-bottom {
  display: none !important;
}
@media (max-width: 991px) {
  header {
    position: sticky;
  }
  .head {
    height: auto;
    min-height: 72px;
    gap: 14px;
    flex-wrap: wrap;
    padding: 9px 0 12px;
  }
  .logo {
    width:auto;
  }
  .logo img{width:132px;max-height:40px}
  .mobile-bottom {
    display: grid !important;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: 58px;
    background: #fff;
    border-top: 1px solid var(--line);
    grid-template-columns: repeat(5, 1fr);
    z-index: 60;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.06);
  }
  .mobile-bottom a,
  .mobile-bottom button,
  .mobile-bottom .disabled-nav {
    border: 0;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction:column;
    gap: 3px;
    font-size: 11px;
    color: #666;
    padding: 0 2px;
  }
  .mobile-bottom svg { font-size:17px; }
  .bottom-icon { position:relative; display:inline-flex; }
  .bottom-icon b { position:absolute; top:-9px; right:-14px; }
  .mobile-bottom .disabled-nav { opacity:.55; cursor:not-allowed; }
  .mobile-bottom a.router-link-exact-active {
    color: var(--brand);
  }
  .mobile-bottom a:active,.mobile-bottom button:active{background:var(--brand-soft)}
}
@media (max-width: 479px) {
  .head {
    gap: 10px;
  }
  .logo {
    width:auto;
  }
  .logo img{width:112px}
}
@media (min-width:1200px) {
  header > .container, .utility .container { max-width:1110px; }
  .head { min-height:89px; }
  .logo img { width:145px; }
  header > nav { min-height:48px; }
}
</style>
<style scoped>
header{font-size:var(--font-base);line-height:var(--line-height-base);background:var(--surface)}
.utility-row{height:var(--utility-height)}
.head{min-height:var(--header-height)}
.logo img{width:var(--logo-width)}
.head form{height:var(--search-height)}
header>nav.desktop-only{min-height:var(--nav-height);font-size:var(--font-base);line-height:var(--line-height-base)}
@media(max-width:991px){.head{min-height:72px}.logo img{width:132px}.head form{height:40px}}
@media(max-width:479px){.logo img{width:112px}}
</style>
